import axios from 'axios';
import { BASE_URL } from './EndPoints';

const AxiosClient = (token) => {
    const AxiosClient = axios.create({
        // timeout: 3000,
        baseURL: BASE_URL,
        /* other setting */
        headers: {
            Authorization: token,
        },
    });

    AxiosClient.interceptors.request.use(
        function (config) {
            return config;
        },
        function (error) {
            return Promise.reject(error);
        }
    );
    // const history = useHistory();
    AxiosClient.interceptors.response.use(
        function (response) {
            // Do something with response data
            return response;
        },
        function (error) {
            // Do something with response error
            return Promise.reject(error);
        }
    );
    return AxiosClient;
};

export { AxiosClient };
